import { jsx as n } from "react/jsx-runtime";
import * as m from "react";
import v from "react";
import { P as l } from "./chunks/index.CiR8ycRn.js";
import { c as p } from "./chunks/index.rKuIKazb.js";
import { L as f } from "./chunks/layout.BROMuy9M.js";
import './assets/divider.css';var u = "Separator", s = "horizontal", N = ["horizontal", "vertical"], d = m.forwardRef((r, a) => {
  const { decorative: t, orientation: o = s, ...e } = r, i = O(o) ? o : s, c = t ? { role: "none" } : { "aria-orientation": i === "vertical" ? i : void 0, role: "separator" };
  return /* @__PURE__ */ n(
    l.div,
    {
      "data-orientation": i,
      ...c,
      ...e,
      ref: a
    }
  );
});
d.displayName = u;
function O(r) {
  return N.includes(r);
}
var R = d;
const _ = "_divider_68kqi_3", P = {
  divider: _
}, T = v.forwardRef(
  ({ orientation: r, backgroundColor: a = "div-default", className: t, ...o }, e) => {
    const i = p(P.divider, t);
    return /* @__PURE__ */ n(f, { backgroundColor: a, ...o, asChild: !0, children: /* @__PURE__ */ n(
      R,
      {
        className: i,
        orientation: r,
        ref: e
      }
    ) });
  }
);
T.displayName = "Divider";
export {
  T as Divider
};
//# sourceMappingURL=divider.js.map
